import styled from 'styled-components';

export const Base = styled.div`
	// layout
	padding: 12px;
	display: flex;
	flex-direction: column;

	// style
	border-top: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme }) => theme.gray[0]};
`;

interface InputAreaProps {
	isFocused: boolean;
}

export const InputArea = styled.div<InputAreaProps>`
	// layout
	width: 100%;

	// style
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 4px;
	border: ${({ isFocused, theme }) =>
		isFocused ? `1px solid ${theme.gray[400]}` : '1px solid transparent'};
`;

export const MultilineInputWrapper = styled.div`
	max-height: 120px;
	overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.gray[100]};
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.gray[400]};
		border-radius: 3px;
	}
`;

export const Actions = styled.div`
	// layout
	padding: 4px;
	display: flex;
	justify-content: flex-end;
	gap: 4px;

	// style
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const SubmitButtonWrapper = styled.div`
	padding-top: 4px;
`;

export const ReadOnlyText = styled.div`
	padding: 16px;
	text-align: left;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	line-height: 18px;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
`;
